import {
  useEditorRef,
  useHotkeys,
  useFloatingLinkSelectors,
} from '@udecode/plate';
import { submitFloatingLink } from './submitFloatingLink';

export const useFloatingLinkEnter = () => {
  const editor = useEditorRef();

  const open = useFloatingLinkSelectors().isOpen(editor.id);

  useHotkeys(
    '*',
    (e) => {
      if (e.key !== 'Enter') return;

      if (submitFloatingLink(editor)) {
        e.preventDefault();
      }
    },
    {
      enabled: open,
      enableOnFormTags: ['INPUT'],
    },
    [],
  );
};
